//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// avatar imports
import { AvatarGeneric } from "./AvatarGeneric";
// other components
import { LogoClock } from "@components/logo";

/////////////////////
// COMPONENT
/////////////////////
export const AvatarLogo = ({ size }: { size: number }) => {
  return (
    <AvatarGeneric size={size}>
      <LogoClock size={size * 0.7} fill={"white"} />
    </AvatarGeneric>
  );
};
